import {getStack} from '@ns/ns-contentstack-lib';
import {RunConfigService} from '@nuskin/ns-util';

export async function getStrings() {
  /** @type {import('contentstack').Stack} */
  const Stack = getStack();
  const runConfig = RunConfigService.getRunConfig();
  const lang = runConfig.language === 'in' ? 'id' : runConfig.language;

  const contentTypes = ['storefront_ssr_translations_1'];

  const stringList = await Stack.getSingletonEntries({
    contentTypeUIDs: contentTypes,
    country: runConfig.country,
    language: lang,
    camelcase: true,
    mergeWithFallback: true
  });
  const strings = stringList.map((item) => item.gdprCustompopupmessage);
  return strings;
}
